if (!customElements.get('collection-category')) {
  class CollectionCategory extends HTMLElement {
    constructor() {
      super();

      this.showMoreBtns = this.querySelectorAll('.js-show-more');
    }

    connectedCallback() {
      if (this.showMoreBtns && this.showMoreBtns.length > 0) {
        this.showMoreList();
      }
    }

    showMoreList() {
      this.showMoreBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const isShowing = btn.classList.contains('is-open'),
            ulList = btn.previousElementSibling,
            buttonText = btn.firstElementChild;

          isShowing ? btn.classList.remove('is-open') : btn.classList.add('is-open');

          if (isShowing) buttonText.textContent = window.generalString.viewMore;
          else buttonText.textContent = window.generalString.viewLess;

          if (ulList.style.maxHeight) ulList.style.maxHeight = null;
          else ulList.style.maxHeight = ulList.scrollHeight + 'px';

          ulList.classList.toggle('is-open');
        });
      });
    }
  }

  customElements.define('collection-category', CollectionCategory);
}
